import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { FaClasses } from "@cervval.js/client-html5-core/src/tools/css.tools";
import { PADDING } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { createHtmlElement, setHTMLElementAttributes, setHTMLElementStyle } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { CustomElement, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { CjsIconFa } from "@cervval.js/client-html5-ui/src/components/icon/iconFa";
import { getIconFaName } from "@cervval.js/client-html5-ui/src/components/icon/iconFa.tools";
import { IconFA6 } from "@cervval.js/client-html5-ui/src/components/icon/tools/fontAwesome6IconList.tools";
import { getLogConsole } from "@cervval.js/common/src/services/log.service";
import { i18n, I18nType } from "./i18n/i18n";

const COUNTDOWN_IN_SEC = 10;

@CustomElement({
    name: "disconnected-page",
    style: require("./disconnected.page.scss"),
    template: require("./disconnected.page.html"),
    i18n: i18n
})
export class DisconnectedPage extends WebPageComponent<I18nType> {

    @TypedHtmlElements()
    public component!: {
        disconnectSuccessMessage: HTMLDivElement,
        redirectMessage: HTMLDivElement,
        loadBar: HTMLDivElement
    };

    /** If true, the countdown will be passed */
    private _breakCountdown = false;

    /** @inheritdoc */
    public override init(): Promise<void> | void {

        const label = createHtmlElement("div", { innerHTML: [this.i18n.redirect.label], cssClass: [PADDING.PE_2] });
        const icon = new CjsIconFa({
            name: getIconFaName(IconFA6.ARROW_UP_RIGHT),
            prefix: FaClasses.SOLID
        });
        const link = createHtmlElement("a", { innerHTML: [this.i18n.redirect.linkName], cssClass: [PADDING.PE_2, "link"] });

        link.addEventListener("click", () => this._breakCountdown = true);

        this.component.redirectMessage.append(...[label, link, icon]);

        const appName = createHtmlElement("strong", { innerHTML: [this.i18n.disconnect.from], cssClass: [PADDING.PS_2] });
        this.component.disconnectSuccessMessage.append(...[this.i18n.disconnect.success, appName]);

    }

    /** @inheritdoc */
    public override refresh(): void {
        this._setBarAdvancement(0);
        this._breakCountdown = false;
        this._countdown().then((result) => {
            if (!result) { return; }
            this._redirect();
        }).catch(getLogConsole().error);
    }

    /** Set a countdown before redirect */
    private _countdown(): Promise<boolean> {
        const promise = new Promise<boolean>((resolve, reject) => {
            try {
                let counter = 0;
                const maxValue = COUNTDOWN_IN_SEC;
                const timeout = setInterval(() => {
                    counter += 0.10;
                    const percent = Math.ceil((counter / maxValue) * 100);
                    this._setBarAdvancement(percent);
                    if (counter >= maxValue || this._breakCountdown) {
                        clearInterval(timeout);
                        resolve(true);
                    }
                }, 100);
            } catch (e) {
                reject(e);
            }

        });

        return promise;
    }

    /** Redirect to CAS */
    private _redirect(): void {
        window.location.assign("../afterLogout");
    }

    /** Display countdown advancement */
    private _setBarAdvancement(percent: number): void {
        setHTMLElementStyle(this.component.loadBar, {
            width: `${percent}%`
        });
        setHTMLElementAttributes(this.component.loadBar, {
            "aria-valuenow": `${percent}`
        });
    }
}